import {
  ConvenienceFee,
  ConvenienceFeeRes,
  SaleTaxRate,
} from '@src/types/feeSettings';
import axios, { AxiosResponse } from 'axios';

export const getTaxAndFee = async (): Promise<
  AxiosResponse<ConvenienceFeeRes>
> => {
  return axios.get('/tax-and-fee/');
};

export const updateTaxAndFee = async (
  data: Partial<ConvenienceFee>
): Promise<AxiosResponse<ConvenienceFeeRes>> => {
  return axios.post('/tax-and-fee/', data);
};

export const getSaleTaxRate = async (): Promise<
  AxiosResponse<SaleTaxRate[]>
> => {
  return axios.get('/sale-tax-rate/');
};

export const createSaleTaxRate = async (data: Omit<SaleTaxRate, 'id'>) => {
  return axios.post('/sale-tax-rate/', data);
};

export const updateSaleTaxRate = async (
  configId: number,
  data: Omit<SaleTaxRate, 'id'>
) => {
  return axios.put(`/sale-tax-rate/${configId}/`, data);
};

export const deleteSaleTaxRate = async (configId: number) => {
  return axios.delete(`/sale-tax-rate/${configId}/`);
};
